import React, { useState, useEffect } from "react";
import axios from "axios";

const BASE_URL = "https://api.malidag.com";

const KidsHeader = () => {
  const [selectedType, setSelectedType] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [kidTypes, setKidTypes] = useState([]);

  // ✅ Fetch available kid genre-type pairs
  useEffect(() => {
    const fetchKidTypes = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/items`);
        const data = response.data;

        const allowedGenres = ["boy", "girl", "baby boy", "baby girl"];

        const kidsItems = data.filter((item) => {
          const genre = item.item?.genre?.toLowerCase();
          const type = item.item?.type?.toLowerCase();
          return allowedGenres.includes(genre) && !!type;
        });

        const uniquePairs = [
          ...new Set(
            kidsItems.map(
              (item) =>
                `${item.item.genre.toLowerCase()}-${item.item.type.toLowerCase()}`
            )
          ),
        ];

        setKidTypes(uniquePairs);
      } catch (error) {
        console.error("❌ Error fetching kids items:", error);
      }
    };

    fetchKidTypes();
  }, []);

  // ✅ Handle dropdown change
  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    setImageUrl(null);
  };

  // ✅ Upload image to backend (which sends to R2 + MongoDB)
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedType) {
      alert("Please select a genre-type before uploading an image.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      setLoading(true);

      const response = await axios.post(
        `${BASE_URL}/kids/${selectedType}/image`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // ✅ R2 URL returned from backend
      setImageUrl(response.data.image.imageUrl);
      console.log("✅ Upload successful:", response.data.image.imageUrl);
    } catch (error) {
      console.error("❌ Upload error:", error.response?.data || error.message);
      alert("Failed to upload image. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "30px" }}>
      <h1>Kids Header Upload</h1>

      {/* ✅ Step 1: Select genre-type */}
      <select
        value={selectedType}
        onChange={handleTypeChange}
        style={{
          padding: "10px",
          fontSize: "16px",
          width: "100%",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
      >
        <option value="">Select Genre-Type</option>
        {kidTypes.map((pair) => (
          <option key={pair} value={pair}>
            {pair.replace(/-/g, " ")}
          </option>
        ))}
      </select>

      {/* ✅ Step 2: Choose file (only after selecting type) */}
      {selectedType && (
        <>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            style={{ marginBottom: "20px" }}
          />
          {loading && <p>Uploading...</p>}
        </>
      )}

      {/* ✅ Step 3: Show uploaded image preview */}
      {imageUrl && (
        <div>
          <h2>Uploaded Image for {selectedType.replace(/-/g, " ")}</h2>
          <img
            src={imageUrl}
            alt={selectedType}
            style={{
              width: "100%",
              maxWidth: "900px",
              borderRadius: "10px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default KidsHeader;
